import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@mui/styles";
import Agreement from "@/components/Agreement";
import { useNavigate, useParams } from "react-router-dom";
import { Navbar } from "./navBar";
import { createNewWait } from "@/apis";
import { setLoading } from "@/store/slices/feedback";
import confirmationIcon from "../../assets/confirmation.svg";
import { BigButton } from "@/components/button";
import { useQuery } from "@/utils";
import { useGlobalState } from "@/hooks/useGlobalState";
import { useMemo, useState } from "react";
import Message from "@/components/Message";
import useCRM from "@/hooks/useCRM";

const useStyles = makeStyles({
  root: {
    textAlign: "center",
    color: "#4a4f54",
  },
  icon: {
    width: 189,
    height: 236,
    margin: "0 auto",
    marginBottom: 43,
    "@media (max-height: 768px)": {
      marginTop: -20,
    },
  },
  iconImg: {
    width: 189,
    height: 236,
  },
  name: {
    fontSize: 36,
    fontWeight: 500,
  },
  phone: {
    marginTop: 20,
    fontSize: 30,
  },
  invisible: {
    visibility: "hidden",
  },
});

export default () => {
  const [language] = useGlobalState("language");
  const classes = useStyles();
  const navigate = useNavigate();
  const { merchantId } = useParams();
  const dispatch = useDispatch();
  const { mode } = useQuery();
  const newWait = useSelector((state) => state.waitlist.edit.value);
  const { partySize, name, phone } = newWait;
  const backPage = window.location.pathname.replace(/\/[^\/]*$/, "/contact");
  const startPage = window.location.pathname.replace(/\/[^\/]*$/, "/start");
  const { isCRMOpen, checkCRMMember } = useCRM(merchantId, "front");

  const onJoin = async () => {
    try {
      dispatch(setLoading(true));
      const newWaitData = { ...newWait, phone: phone.replace(/\D/g, "") };
      const res = await createNewWait(merchantId, newWaitData);
      const { waitId } = res.data;
      let isNavigateToCRM = false;
      // 1. 判断是否开通crm
      if (isCRMOpen) {
        // 2. 判断是否已经是会员
        isNavigateToCRM = !(await checkCRMMember(phone));
      }
      let nextPage = window.location.pathname.replace(
        /\/[^\/]*$/,
        `/${isNavigateToCRM ? "crmLogin" : "waitingNumber"}?id=${waitId}`
      );
      if (mode) {
        nextPage += `&mode=${mode}`;
      }
      navigate(nextPage);
    } catch (e) {
      if (e?.response) {
        const {
          data: { description },
        } = e.response;
        Message.error({ content: description });
      }
    } finally {
      dispatch(setLoading(false));
    }
  };

  const isShowCn = useMemo(() => {
    return language.includes("zh");
  }, [language]);

  return (
    <div className={classes.root}>
      <Navbar
        backUrl={backPage}
        closeUrl={startPage}
        invisible={mode === "kiosk"}
      />
      <div className={classes.icon}>
        <img className={classes.iconImg} src={confirmationIcon} />
      </div>
      <div className={classes.name}>{name}</div>
      <div className={classes.phone}>{phone}</div>
      <div className={classes.phone}>
        <span>Party of {partySize}</span>
        {isShowCn && <span>({partySize}人桌)</span>}
      </div>
      <BigButton onClick={onJoin} mode={mode}>
        <span>Join</span>
        {isShowCn && <span>(确认)</span>}
      </BigButton>
      <Agreement textColor="#555" />
    </div>
  );
};
